import { isGroupedFilters } from '@/utils/QueryHelpers'
import { CompositeFilterDescriptor } from '@progress/kendo-data-query'

const IB_REBATES_TA_SETTINGS_PREFIXED_FIELDS = new Set([
  'HasRebate',
  'HasTradingAccountRebate',
  'HasGroupRebate',
  'GroupName',
  'RebateApprovalType',
  'RebatePeriod',
  'Amount',
])

export const prefixFilterValues = (
  filter: CompositeFilterDescriptor,
  brokerId: string
): CompositeFilterDescriptor => ({
  ...filter,
  filters: filter.filters.map((f) => {
    if (isGroupedFilters(f)) {
      return prefixFilterValues(f, brokerId)
    }

    if (
      typeof f.field === 'string' &&
      IB_REBATES_TA_SETTINGS_PREFIXED_FIELDS.has(f.field) &&
      f.value !== undefined &&
      f.value !== null
    ) {
      return { ...f, value: `${brokerId}__${f.value}` }
    }

    return f
  }),
})
